/**
 * Referral code helpers.
 *
 * When a visitor lands with ?ref=PIP-XXXXXX in the URL we stash it in localStorage
 * for 60 days, then attach it to the next checkout request.
 */
const KEY = "pip_ref_code";
const MAX_AGE_DAYS = 60;

export function captureRefCodeFromUrl() {
  try {
    const params = new URLSearchParams(window.location.search);
    const ref = (params.get("ref") || "").trim().toUpperCase();
    if (!ref) return;
    localStorage.setItem(
      KEY,
      JSON.stringify({ code: ref, t: Date.now() }),
    );
  } catch {
    /* ignore — Safari private mode etc */
  }
}

export function getRefCode() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return "";
    const { code, t } = JSON.parse(raw);
    if (!code) return "";
    const ageDays = (Date.now() - (t || 0)) / (1000 * 60 * 60 * 24);
    if (ageDays > MAX_AGE_DAYS) {
      localStorage.removeItem(KEY);
      return "";
    }
    return code;
  } catch {
    return "";
  }
}

export function clearRefCode() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
